module.exports = __webpack_public_path__ + "static/logo-05c7c82eb7146a7e41d041e56b6281d7.png";